import { patchCaseParams } from '@/api/cases';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { getMonteCarloNodes, reconstructNestedParams } from '@/utils/pathwayUtils';

const initialValues = { params: {}, schemas: [] };
const useNodesStore = create()(immer(() => initialValues));
const { setState: set, getState: get } = useNodesStore;

export const nodesActions = {
  init: (nodes, schemas) => set({ nodes, schemas }),
  updateParams: async (nodeId, params) => {
    const { schemas } = get();
    const { filteredCaseNodes } = getMonteCarloNodes(schemas, { [nodeId]: { params } });
    const flattenedParams = filteredCaseNodes[nodeId]?.params || params;

    set(state => {
      state.nodes[nodeId] = { params: flattenedParams };
    });
  },

  toggleAllParams: async (caseId, uncertaintyActive) => {
    const flattenedNodes = get().nodes;
    const nestedNodes = reconstructNestedParams(flattenedNodes, uncertaintyActive);
    const { data } = await patchCaseParams(caseId, nestedNodes);

    const { filteredNodes, filteredCaseNodes } = getMonteCarloNodes(get().schemas, data);

    nodesActions.init(filteredCaseNodes, filteredNodes);

    return data;
  },

  checkAllParams: caseId => {
    return nodesActions.toggleAllParams(caseId, true);
  },

  uncheckAllParams: caseId => {
    return nodesActions.toggleAllParams(caseId, false);
  },

  clear: () => set(initialValues, true),
};

export const useCaseNodes = () => useNodesStore(store => store?.nodes);

export const useAreAllParamsChecked = () => {
  return useNodesStore(store => {
    return Object.values(store.nodes).every(node =>
      Object.values(node.params).every(param => param?.uncertainty_active?.value === true),
    );
  });
};

export const useAreAllParamsUnchecked = () => {
  return useNodesStore(store => {
    return Object.values(store.nodes).every(node =>
      Object.values(node.params).every(param => param?.uncertainty_active?.value === false),
    );
  });
};

export default useNodesStore;
